import React, { useState, useEffect, useRef } from "react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { toast } from "react-toastify";
import Select from "react-select";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import { useLocation, useNavigate } from "react-router-dom";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminSliderModal from "../../../components/CommonComponents/AdminSliderModal";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import AdminCustomPasswordInput from "../../../components/CommonComponents/AdminCustomPasswordInput";
import AdminCustomArea from "../../../components/CommonComponents/AdminCustomArea";
import AdminAwsBucketSelectModal from "../../../components/CommonComponents/AdminAwsBucketSelectModal";
import AdminBunnyCdnSyncModal from "../../../components/CommonComponents/AdminBunnyCdnSyncModal";
import { MdRefresh } from "react-icons/md";

function StorageSettings() {
  const { fetchRequest } = useMyContext()
  const { location } = useLocation()
  const navigate = useNavigate()
  const baseURL = process.env.REACT_APP_Baseurl
  const indexApi = `${baseURL}/admin/storage_index`;
  const labelApi = `${baseURL}/admin/Label-Management/list-source`
  const updateApi = `${baseURL}/admin/storage_update`

  const combinedRef = useRef({});

  const [formData, setFormData] = useState({})
  const [formDataError, setFormDataError] = useState({})
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [loading, setLoading] = useState(true)
  const [showOverlay, setShowOverlay] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [activeStorage, setActiveStorage] = useState(false);
  const [streamGenerating, setStreamGenerating] = useState(false);
  const [storageGenerating, setStorageGenerating] = useState(false);
  const [fetchingBuckets, setFetchingBuckets] = useState(false);
  const [s3Buckets, setS3Buckets] = useState([]);
  const [showBucketModal, setShowBucketModal] = useState(false);
  const [activeBucketField, setActiveBucketField] = useState("");
  const [sslModalConfig, setSslModalConfig] = useState(null);
  const [showBunnySyncModal, setShowBunnySyncModal] = useState(false);
  const [generatedPublicKey, setGeneratedPublicKey] = useState('');
  const [isGeneratingKeyPair, setIsGeneratingKeyPair] = useState(false);
  const [cfKeyFileExists, setCfKeyFileExists] = useState(false);
  const storageKeys = ["site_storage", "aws_storage", "bunny_cdn_storage", "flussonic_storage", "videocipher_storage", "sftp_storage", "gcs_storage"];
  const simpleToggleKeys = [
    "bunny_cdn_frontend_asset_enabled",
    "bunny_cdn_stream_token_auth_ip_restrict",
    "bunny_cdn_storage_token_auth_ip_restrict",
    // GCS signed-URL preference is an inner option, not a storage-type switch.
    "gcs_signed_urls_enabled",
  ];
  const [tokenAuthTestLoading, setTokenAuthTestLoading] = useState(false);
  const [tokenAuthTestResult, setTokenAuthTestResult] = useState(null);
  const [fetchingTokenKey, setFetchingTokenKey] = useState(false);
  const [togglingCdnAuth, setTogglingCdnAuth] = useState(false);

  // Storage Token Authentication state
  const [storageTokenAuthTestLoading, setStorageTokenAuthTestLoading] = useState(false);
  const [storageTokenAuthTestResult, setStorageTokenAuthTestResult] = useState(null);
  const [fetchingStorageTokenKey, setFetchingStorageTokenKey] = useState(false);
  const [togglingStorageCdnAuth, setTogglingStorageCdnAuth] = useState(false);

  const placeHolder = (val) => val?.replace(/_/g, ' ')

  const closeModal = () => {
    setShowModal(false);
    setSslModalConfig(null);
  };

  const handleSslToggle = (name, checked) => {
    setSslModalConfig({ name, checked });
  };

  const confirmSslToggle = async () => {
    if (!sslModalConfig) return;
    const { name, checked } = sslModalConfig;
    const type = name.includes('force_ssl') ? 'force_ssl' : 'ssl';
    const category = name.includes('storage') ? 'storage-zone' : 'stream';

    setShowOverlay(true);
    setSslModalConfig(null);
    try {
      const response = await fetchRequest({
        method: 'POST',
        url: `${baseURL}/admin/toggle-bunny-ssl`,
        data: { type, enabled: checked, category }
      });

      if (response?.status) {
        toast.success(response.message);
        setFormData(prev => ({ ...prev, [name]: checked ? 1 : 0 }));
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to update SSL settings.");
    } finally {
      setShowOverlay(false);
    }
  };

  const handleInput = (e) => {
    const { name, type, value, checked } = e.target;
    const directToggleKeys = ["aws_transcode_status", "aws_cloudfront_enabled", "transcoding_access", ...simpleToggleKeys];

    if (type === "checkbox" && directToggleKeys.includes(name)) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: checked ? 1 : 0
      }));
    }

    setFormDataError((prevEditUser) => ({
      ...prevEditUser,
      [name]: '',
    }));
    if (type === "checkbox" && name === "aws_cloudfront_signed_urls_enabled") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: checked ? 1 : 0
      }));
      return;
    }

    if (type === 'checkbox' && !directToggleKeys.includes(name) && name !== "aws_cloudfront_signed_urls_enabled") {

      if (name === 'brightcove_storage') {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: checked ? 1 : 0
        }));
      } else {
        setShowModal(true)
        setActiveStorage(name)
      }
    }
    if (type === "text" || type === "password" || type === 'select-one') {
      setFormData((prevEditUser) => ({
        ...prevEditUser,
        [name]: value,
      }));
    }

    if (type === "number") {
      if (name === "site_storage_limit") {

        const numericValue = parseInt(value, 10);
        let currentUnit = formData?.site_storage_memory;

        if (!isNaN(numericValue)) {
          let newValue = numericValue;
          let newUnit = currentUnit;

          // Convert up units if value >= 1000 (decimal: 1 GB = 1000 MB, 1 TB = 1000 GB)
          while (newValue >= 1000) {
            if (newUnit === "MB") {
              newValue = newValue / 1000;
              newUnit = "GB";
            } else if (newUnit === "GB") {
              newValue = newValue / 1000;
              newUnit = "TB";
            } else {
              break; // Already at TB, don't convert further
            }
          }
          setFormData((prev) => ({
            ...prev,
            site_storage_limit: Math.floor(newValue),
            site_storage_memory: newUnit
          }));
          return;
        }
      }
      setFormData((prev) => ({
        ...prev,
        [name]: value
      }));

    }
  }

  const handleMultiSelect = (selectedOptions, actionMeta) => {
    setFormData((prev) => ({
      ...prev,
      [actionMeta.name]: selectedOptions
    }))
    setFormDataError((prev) => ({
      ...prev,
      [actionMeta.name]: ""
    }))
  }

  const multiSelectLabel = (array, valueKey, labelKey) => {
    return Array.isArray(array) ? array?.map((item) => ({
      value: item[valueKey],
      label: item[labelKey]
    })) : [];
  };
  const confirmToggle = async () => {
    setFormData((prev) => {
      const updated = { ...prev };
      storageKeys.forEach((key) => {
        updated[key] = key === activeStorage ? 1 : 0;
      });
      return updated;
    });
    setShowModal(false)
  };

  const labelFetch = async () => {
    try {
      setLoading(true)
      await fetchRequest({
        method: 'GET',
        url: `${labelApi}`,
        params: { source: "storage-settings" },
        data: {},
      }).then((res) => {
        setLabelDisplay(res?.label_management)
      })
    }
    catch (err) {
      toast.error(err?.response?.data?.message)
    }
    finally {
      setLoading(false)
    }
  }

  const formValidation = () => {
    let formIsValid = true;
    if (formData?.videocipher_storage == 1) {
      if (!formData?.videocipher_PPV_Resolution?.length) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          videocipher_PPV_Resolution: "Please provide resolution.",
        }));
        combinedRef.current['videocipher_PPV_Resolution'].focus()
        formIsValid = false;
      }
      if (!formData?.videocipher_ApiKey) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          videocipher_ApiKey: "videocipher_ApiKey cannot be empty.",
        }));
        combinedRef.current['videocipher_ApiKey'].focus()
        formIsValid = false;
      }
    }
    if (formData?.bunny_cdn_storage == 1) {
      if (!formData?.bunny_cdn_access_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          bunny_cdn_access_key: "CDN storage access key is required.",
        }));
        combinedRef.current['bunny_cdn_access_key'].focus()
        formIsValid = false;
      }
      if (!formData?.bunny_cdn_storage_zone_name) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          bunny_cdn_storage_zone_name: "Storage zone name is required.",
        }));
        combinedRef.current['bunny_cdn_storage_zone_name'].focus()
        formIsValid = false;
      }
      if (!formData?.bunny_cdn_storage_host_name) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          bunny_cdn_storage_host_name: "Storage hostname is required.",
        }));
        combinedRef.current['bunny_cdn_storage_host_name'].focus()
        formIsValid = false;
      }
      if (!formData?.bunny_cdn_stream_access_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          bunny_cdn_stream_access_key: "Stream access key is required.",
        }));
        combinedRef.current['bunny_cdn_stream_access_key'].focus()
        formIsValid = false;
      }
    }
    if (formData?.bunny_cdn_frontend_asset_enabled == 1) {
      if (!formData?.bunny_cdn_frontend_asset_url) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          bunny_cdn_frontend_asset_url: "Frontend asset CDN URL is required.",
        }));
        combinedRef.current['bunny_cdn_frontend_asset_url']?.focus()
        formIsValid = false;
      } else {
        try {
          new URL(formData.bunny_cdn_frontend_asset_url.startsWith('http') ? formData.bunny_cdn_frontend_asset_url : `https://${formData.bunny_cdn_frontend_asset_url}`);
        } catch {
          setFormDataError((prevFormData) => ({
            ...prevFormData,
            bunny_cdn_frontend_asset_url: "Please enter a valid CDN URL.",
            bunny_cdn_access_key: "CDN storage access key is required.",
          }));
          combinedRef.current['bunny_cdn_frontend_asset_url']?.focus()
          formIsValid = false;
        }
      }
    }
    if (formData?.bunny_cdn_stream_token_auth_enabled == 1) {
      if (!formData?.bunny_cdn_stream_token_auth_key?.trim()) {
        // Key is readonly — user must click "Fetch from CDN" to populate it
        toast.error('Token Authentication Key is missing. Click "Fetch from CDN" to sync it.');
        formIsValid = false;
      }
      const ttl = Number(formData?.bunny_cdn_stream_token_auth_ttl);
      if (!ttl || ttl < 60 || ttl > 86400) {
        setFormDataError(prev => ({ ...prev, bunny_cdn_stream_token_auth_ttl: "TTL must be between 60 and 86400 seconds." }));
        combinedRef.current['bunny_cdn_stream_token_auth_ttl']?.focus();
        formIsValid = false;
      }
    }
    if (formData?.site_storage == 1) {
      if (!formData?.site_storage_limit) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          site_storage_limit: "Please provide Maximum Upload Size.",
        }));
        combinedRef.current['site_storage_limit'].focus()
        formIsValid = false;
      }
      if (!formData?.site_storage_memory) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          site_storage_memory: "Please provide Storage Unit.",
        }));
        combinedRef.current['site_storage_memory'].focus()
        formIsValid = false;
      }
    }
    if (formData?.sftp_storage == 1) {
      // Domain URL validation
      if (!formData?.domain_url) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          domain_url: "Domain URL is required.",
        }));
        combinedRef.current['domain_url'].focus()
        formIsValid = false;
      } else if (
        !formData.domain_url.startsWith('https://') &&
        !formData.domain_url.startsWith('http://')
      ) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          domain_url: "Domain URL must start with https:// or http://",
        }));
        combinedRef.current['domain_url'].focus();
        formIsValid = false;
      }
      else {
        try {
          new URL(formData.domain_url);
        } catch {
          setFormDataError((prevFormData) => ({
            ...prevFormData,
            domain_url: "Please enter a valid URL.",
          }));
          combinedRef.current['domain_url'].focus()
          formIsValid = false;
        }
      }

      // Host validation
      if (!formData?.sftp_host) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          sftp_host: "SFTP host is required.",
        }));
        combinedRef.current['sftp_host'].focus()
        formIsValid = false;
      }

      // Port validation
      if (!formData?.sftp_port) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          sftp_port: "SFTP port is required.",
        }));
        combinedRef.current['sftp_port'].focus()
        formIsValid = false;
      } else {
        const port = parseInt(formData.sftp_port, 10);
        if (isNaN(port) || port < 1 || port > 65535) {
          setFormDataError((prevFormData) => ({
            ...prevFormData,
            sftp_port: "Port must be a number between 1 and 65535.",
          }));
          combinedRef.current['sftp_port'].focus()
          formIsValid = false;
        }
      }

      // Username validation
      if (!formData?.sftp_username) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          sftp_username: "SFTP username is required.",
        }));
        combinedRef.current['sftp_username'].focus()
        formIsValid = false;
      }

      // Password validation
      if (!formData?.sftp_password) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          sftp_password: "SFTP password is required.",
        }));
        combinedRef.current['sftp_password'].focus()
        formIsValid = false;
      } else if (formData.sftp_password.length < 6) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          sftp_password: "Password must be at least 6 characters long.",
        }));
        combinedRef.current['sftp_password'].focus()
        formIsValid = false;
      }
    }
    if (formData?.brightcove_storage == 1) {
      if (!formData?.account_id) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          account_id: "Account ID is required.",
        }));
        combinedRef.current['account_id']?.focus()
        formIsValid = false;
      }
      if (!formData?.client_id) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          client_id: "Client ID is required.",
        }));
        combinedRef.current['client_id']?.focus()
        formIsValid = false;
      }
      if (!formData?.client_secret) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          client_secret: "Client Secret is required.",
        }));
        combinedRef.current['client_secret']?.focus()
        formIsValid = false;
      }
      if (!formData?.policy_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          policy_key: "Policy Key is required.",
        }));
        combinedRef.current['policy_key']?.focus()
        formIsValid = false;
      }
    }
    return formIsValid;

  }

  const handleAction = async () => {
    if (!formValidation()) {
      return
    }
    setShowOverlay(true);
    try {
      const formDataAdd = {};

      for (const key in formData) {
        if (["Meta_description", "website_page_title", "website_URL"].includes(key)) {
          formDataAdd[key] = formData[key]
        }
      }


      for (const key in formData) {
        if (!["videocipher_PPV_Resolution"].includes(key)) {
          formDataAdd[key] = formData[key];
        }
      }
      formDataAdd.videocipher_PPV_Resolution = formData?.videocipher_PPV_Resolution?.map((item) => item?.value || "").join(",")

      console.log('Form data being sent:', formDataAdd); // Debug log

      if (formData.brightcove_storage === 1) {
        console.log("Validating and Saving Brightcove Credentials...");
        const brightcoveValidation = await fetchRequest({
          url: `${baseURL}/admin/brightcove/settings`, // Use standard settings endpoint
          method: 'POST',
          data: {
            account_id: formData.account_id,
            client_id: formData.client_id,
            client_secret: formData.client_secret,
            policy_key: formData.policy_key,
            api_base_url: formData.api_base_url,
            cache_duration: formData.cache_duration,
            status: 1
          }
        });

        if (!brightcoveValidation.status) {
          toast.error(brightcoveValidation.message || "Brightcove Validation Failed");
          return; // Stop saving if validation fails
        } else {
          toast.success("Brightcove Credentials Validated!");
        }
      }

      const result = await fetchRequest({
        url: updateApi,
        method: "PATCH",
        data: { ...formDataAdd, brightcove_storage: formData.brightcove_storage, transcoding_access: 1 }
      })
      console.log(result, "resultresultresultresult")
      if (result.status) {
        toast.success(result.message)
        setWithOutRefresh(prev => !prev)
      } else {
        toast.error(result.message)
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'An error occurred.');
    } finally {
      setShowOverlay(false);
    }
  }

  const generateStream = async () => {
    if (!formData?.bunny_cdn_global_access_key) {
      toast.error("Please provide a CDN Global Access Key first.");
      return;
    }
    setStreamGenerating(true);
    try {
      const response = await fetchRequest({
        method: 'POST',
        url: `${baseURL}/admin/generate-bunny-stream`,
        data: {
          name: formData?.bunny_cdn_storage_zone_name,
          globalApiKey: formData?.bunny_cdn_global_access_key,
          webhookUrl: `${baseURL}/admin/library/bunnycdn-stream-webhook`
        }
      });
      if (response?.status) {
        toast.success(response.message);
        setFormData(prev => ({
          ...prev,
          bunny_cdn_stream_library_id: response.data.libraryId,
          bunny_cdn_stream_access_key: response.data.apiKey,
          bunny_cdn_stream_cdn_host_name: response.data.streamHost
        }));
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to generate stream.");
    } finally {
      setStreamGenerating(false);
    }
  }

  const generateStorage = async () => {
    if (!formData?.bunny_cdn_global_access_key) {
      toast.error("Please provide a CDN Global Access Key first.");
      return;
    }
    setStorageGenerating(true);
    try {
      const response = await fetchRequest({
        method: 'POST',
        url: `${baseURL}/admin/generate-bunny-storage`,
        data: {
          name: formData?.bunny_cdn_storage_zone_name,
          region: formData?.bunny_cdn_region,
          port: formData?.bunny_cdn_storage_port,
          connectionType: formData?.bunny_cdn_storage_connection_type,
          globalApiKey: formData?.bunny_cdn_global_access_key
        }
      });
      if (response?.status) {
        toast.success(response.message);
        setFormData(prev => ({
          ...prev,
          bunny_cdn_storage_zone_name: response.data.storageZoneName,
          bunny_cdn_storage_host_name: response.data.host,
          bunny_cdn_storage_port: response.data.storagePort,
          bunny_cdn_storage_connection_type: response.data.storageConnectionType,
          bunny_cdn_access_key: response.data.accessKey,
          bunny_cdn_region: response.data.region,
          bunny_cdn_cdn_linked_host_name: response.data.cdnLinkedHostname,
          bunny_cdn_origin_pull_zone_name: response.data.originPullZoneName
        }));
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to generate storage.");
    } finally {
      setStorageGenerating(false);
    }
  }

  const fetchS3Buckets = async (fieldName) => {
    if (!formData?.aws_access_key || !formData?.aws_secret_key || !formData?.aws_region) {
      toast.error("Please provide AWS Access Key, Secret Key, and Region first.");
      return;
    }

    setFetchingBuckets(true);
    setActiveBucketField(fieldName);
    try {
      const response = await fetchRequest({
        method: 'POST',
        url: `${baseURL}/admin/storage/list-buckets`,
        data: {
          accessKey: formData.aws_access_key,
          secretKey: formData.aws_secret_key,
          region: formData.aws_region
        }
      });

      if (response?.status) {
        setS3Buckets(response.buckets || []);
        setShowBucketModal(true);
      } else {
        toast.error(response.message || "Failed to fetch buckets.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to connect to AWS. Check your credentials.");
    } finally {
      setFetchingBuckets(false);
    }
  };

  // ── Auto-fetch Stream Token Auth key from BunnyCDN pull zone ────────────────
  const handleFetchStreamTokenKey = async () => {
    setFetchingTokenKey(true);
    setTokenAuthTestResult(null);
    try {
      const response = await fetchRequest({
        method: 'GET',
        url: `${baseURL}/admin/bunny-cdn-stream-token-auth/key`,
      });
      if (response?.status) {
        toast.success(response.message);
        setFormData(prev => ({
          ...prev,
          bunny_cdn_stream_token_auth_key: response.tokenAuthKey || prev.bunny_cdn_stream_token_auth_key,
          bunny_cdn_stream_token_auth_enabled: response.tokenAuthEnabled ? 1 : 0,
          bunny_cdn_stream_token_auth_ip_restrict: response.ipRestrict ? 1 : 0,
        }));
      } else {
        toast.error(response?.message || 'Failed to fetch token key.');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to fetch token key.');
    } finally {
      setFetchingTokenKey(false);
    }
  };

  // ── CDN Token Auth toggle — calls BunnyCDN API directly ─────────────────────
  const handleTokenAuthToggle = async (enabled) => {
    setTogglingCdnAuth(true);
    try {
      const response = await fetchRequest({
        method: 'POST',
        url: `${baseURL}/admin/bunny-cdn-stream-token-auth/toggle`,
        data: { enabled },
      });
      if (response?.status) {
        toast.success(response.message);
        setFormData(prev => ({
          ...prev,
          bunny_cdn_stream_token_auth_enabled: response.tokenAuthEnabled ? 1 : 0,
          bunny_cdn_stream_token_auth_key: response.tokenAuthKey || prev.bunny_cdn_stream_token_auth_key,
          bunny_cdn_stream_token_auth_ip_restrict: response.ipRestrict ? 1 : 0,
        }));
      } else {
        toast.error(response?.message || 'Failed to update CDN Token Authentication.');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to update CDN Token Authentication.');
    } finally {
      setTogglingCdnAuth(false);
    }
  };

  // ── BunnyCDN Token Auth test helper ─────────────────────────────────────────
  const handleTestTokenAuth = async () => {
    setTokenAuthTestLoading(true);
    setTokenAuthTestResult(null);
    try {
      const response = await fetchRequest({
        method: 'POST',
        url: `${baseURL}/admin/bunny/token-auth/test`,
        data: {},
      });
      setTokenAuthTestResult(response);
    } catch (err) {
      setTokenAuthTestResult({
        status: false,
        detail: err?.response?.data?.message || err?.message || 'Test request failed.',
      });
    } finally {
      setTokenAuthTestLoading(false);
    }
  };

  // ── Storage Library Token Auth helpers ───────────────────────────────────────

  const handleFetchStorageTokenKey = async () => {
    setFetchingStorageTokenKey(true);
    try {
      const response = await fetchRequest({
        method: 'GET',
        url: `${baseURL}/admin/bunny/storage-token-auth/key`,
      });
      if (response?.status) {
        const liveKey = response.tokenAuthKey;
        toast.success(response.message || 'Storage token key fetched.');
        setFormData(prev => ({
          ...prev,
          bunny_cdn_storage_token_auth_key    : liveKey || prev.bunny_cdn_storage_token_auth_key,
          bunny_cdn_storage_token_auth_enabled: response.tokenAuthEnabled ? 1 : 0,
        }));
      } else {
        toast.error(response?.message || 'Failed to fetch storage token key.');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to fetch storage token key.');
    } finally {
      setFetchingStorageTokenKey(false);
    }
  };

  /** Toggle Storage CDN Zone Security directly on BunnyCDN. */
  const handleStorageTokenAuthToggle = async (checked) => {
    setTogglingStorageCdnAuth(true);
    try {
      const response = await fetchRequest({
        method: 'POST',
        url   : `${baseURL}/admin/bunny/storage-cdn-token-auth/toggle`,
        data  : { enabled: checked },
      });
      if (response?.status) {
        toast.success(response.message);
        setFormData(prev => ({
          ...prev,
          bunny_cdn_storage_token_auth_enabled: response.tokenAuthEnabled ? 1 : 0,
          bunny_cdn_storage_token_auth_key    : response.tokenAuthKey || prev.bunny_cdn_storage_token_auth_key,
        }));
        setStorageTokenAuthTestResult(null);
      } else {
        toast.error(response?.message || 'Failed to update Storage CDN Token Authentication.');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to update Storage CDN Token Authentication.');
    } finally {
      setTogglingStorageCdnAuth(false);
    }
  };

    /** Test storage token auth: generate a signed probe URL and validate against the CDN. */
  const handleTestStorageTokenAuth = async () => {
    setStorageTokenAuthTestLoading(true);
    setStorageTokenAuthTestResult(null);
    try {
      const response = await fetchRequest({
        method: 'POST',
        url: `${baseURL}/admin/bunny/storage-token-auth/test`,
        data: {},
      });
      setStorageTokenAuthTestResult(response);
    } catch (err) {
      setStorageTokenAuthTestResult({
        status: false,
        detail: err?.response?.data?.message || err?.message || 'Test request failed.',
      });
    } finally {
      setStorageTokenAuthTestLoading(false);
    }
  };

  /** Update TTL for both Stream and Storage CDNs from a single input. */
  const handleCommonTTL = (e) => {
    const ttl = e.target.value;
    setFormData(prev => ({
      ...prev,
      bunny_cdn_stream_token_auth_ttl: ttl,
      bunny_cdn_storage_token_auth_ttl: ttl,
    }));
    setFormDataError(prev => ({ ...prev, bunny_cdn_stream_token_auth_ttl: '' }));
  };

  /** Test both Stream CDN and Storage CDN token auth concurrently. */
  const handleTestBothTokenAuth = async () => {
    setTokenAuthTestLoading(true);
    setTokenAuthTestResult(null);
    setStorageTokenAuthTestResult(null);
    try {
      const [streamRes, storageRes] = await Promise.allSettled([
        fetchRequest({ method: 'POST', url: `${baseURL}/admin/bunny/token-auth/test`, data: {} }),
        fetchRequest({
          method: 'POST',
          url   : `${baseURL}/admin/bunny/storage-token-auth/test`,
          // Pass the key from the form so the test works even before settings are saved
          data  : { tokenKey: formData?.bunny_cdn_storage_token_auth_key || undefined },
        }),
      ]);
      setTokenAuthTestResult(
        streamRes.status === 'fulfilled' ? streamRes.value
          : { status: false, detail: streamRes.reason?.response?.data?.message || streamRes.reason?.message || 'Stream test failed.' }
      );
      setStorageTokenAuthTestResult(
        storageRes.status === 'fulfilled' ? storageRes.value
          : { status: false, detail: storageRes.reason?.response?.data?.message || storageRes.reason?.message || 'Storage test failed.' }
      );
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || 'Test failed.';
      setTokenAuthTestResult({ status: false, detail: msg });
    } finally {
      setTokenAuthTestLoading(false);
    }
  };

  // ── CloudFront key-pair helpers ───────────────────────────────────────────

  /** Check whether cloudfront-private-key.pem already exists on the server. */
  const checkCfKeyStatus = async () => {
    try {
      const response = await fetchRequest({
        method: 'GET',
        url: `${baseURL}/admin/cloudfront/key-status`,
      });
      if (response?.status) setCfKeyFileExists(response.keyFileExists);
    } catch { /* non-fatal */ }
  };

  /**
   * Generate a fresh RSA-2048 key pair on the server.
   * Private key → saved to config/cloudfront-private-key.pem automatically.
   * Public key  → displayed here so the admin can upload it to AWS CloudFront.
   */
  const generateCloudfrontKeyPair = async () => {
    setIsGeneratingKeyPair(true);
    setGeneratedPublicKey('');
    try {
      const response = await fetchRequest({
        method: 'POST',
        url: `${baseURL}/admin/cloudfront/generate-keypair`,
        data: {},
      });
      if (response?.status) {
        setGeneratedPublicKey(response.publicKey);
        setCfKeyFileExists(true);
        toast.success('Key pair generated! Copy the public key below and upload it to AWS.');
      } else {
        toast.error(response.message || 'Failed to generate key pair.');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to generate key pair.');
    } finally {
      setIsGeneratingKeyPair(false);
    }
  };

  const handleBucketSelect = (bucketName) => {
    setFormData(prev => ({
      ...prev,
      [activeBucketField]: bucketName
    }));
    setShowBucketModal(false);
    setS3Buckets([]);
  };

  useEffect(() => {
    labelFetch()
  }, [])

  useEffect(async () => {
    setLoading(true)
    await fetchRequest({
      method: 'GET',
      url: `${indexApi}`,
      params: {},
      data: {},
    })
      .then(response => {
        if (response?.status) {
          // toast.success(response?.message)
          console.log('Storage API Response:', response?.Storage_setting); // Debug log
          setFormData((prev) => ({
            ...response?.Storage_setting,
            // Map database field names to frontend form field names
            // Google Cloud Storage (column names already match the form names).
            gcs_storage: response?.Storage_setting?.gcs_storage || 0,
            gcs_bucket: response?.Storage_setting?.gcs_bucket || '',
            gcs_project_id: response?.Storage_setting?.gcs_project_id || '',
            gcs_region: response?.Storage_setting?.gcs_region || '',
            gcs_service_account_json: response?.Storage_setting?.gcs_service_account_json || '',
            gcs_public_base_url: response?.Storage_setting?.gcs_public_base_url || '',
            gcs_video_dir: response?.Storage_setting?.gcs_video_dir || 'uploads/videos',
            gcs_audio_dir: response?.Storage_setting?.gcs_audio_dir || 'uploads/audios',
            gcs_image_dir: response?.Storage_setting?.gcs_image_dir || 'uploads',
            gcs_hls_dir: response?.Storage_setting?.gcs_hls_dir || 'uploads/hls',
            gcs_signed_urls_enabled: response?.Storage_setting?.gcs_signed_urls_enabled || 0,
            gcs_signed_url_ttl: response?.Storage_setting?.gcs_signed_url_ttl || 21600,
            bunny_cdn_storage: response?.Storage_setting?.bunnyCdnStorage || 0,
            bunny_cdn_access_key: response?.Storage_setting?.bunnyCdn_storageAccessKey || '',
            bunny_cdn_storage_zone_name: response?.Storage_setting?.bunnyCdn_storageZoneName || '',
            bunny_cdn_storage_host_name: response?.Storage_setting?.bunnyCdn_storageHostName || '',
            brightcove_storage: response?.Storage_setting?.brightcove_storage || 0,
            account_id: response?.Storage_setting?.account_id || '',
            policy_key: response?.Storage_setting?.policy_key || '',
            client_id: response?.Storage_setting?.client_id || '',
            client_secret: response?.Storage_setting?.client_secret || '',
            api_base_url: response?.Storage_setting?.api_base_url || 'https://edge.api.brightcove.com/playback/v1',
            cache_duration: response?.Storage_setting?.cache_duration || 21600,
            bunny_cdn_storage_port: response?.Storage_setting?.bunnyCdn_storagePort || '21',
            bunny_cdn_storage_connection_type: response?.Storage_setting?.bunnyCdn_storageConnectionType || 'ftp',
            bunny_cdn_region: response?.Storage_setting?.bunnyCdn_Region || 'de',
            bunny_cdn_stream_access_key: response?.Storage_setting?.bunnyCdn_streamAccessKey || '',
            bunny_cdn_stream_library_id: response?.Storage_setting?.bunnyCdn_streamLibraryId || '',
            bunny_cdn_stream_cdn_host_name: response?.Storage_setting?.bunnyCdn_streamCdnHostName || '',
            bunny_cdn_stream_webhook_url: `${baseURL}/admin/library/bunnycdn-stream-webhook`,
            bunny_cdn_image_dir: response?.Storage_setting?.bunnyCdn_imageDir || 'uploads',
            bunny_cdn_cdn_linked_host_name: response?.Storage_setting?.bunnyCdn_CdnLinkedHostName || '',
            bunny_cdn_origin_pull_zone_name: response?.Storage_setting?.bunnyCdn_originPullZoneName || '',
            bunny_cdn_video_dir: response?.Storage_setting?.bunnyCdn_videoDir || 'uploads/videos',
            bunny_cdn_audio_dir: response?.Storage_setting?.bunnyCdn_audioDir || 'uploads/audios',
            bunny_cdn_global_access_key: response?.Storage_setting?.bunnyCdn_globalAccessKey || '',
            bunny_cdn_stream_ssl_enabled: response?.Storage_setting?.bunnyCdn_stream_ssl_enabled || false,
            bunny_cdn_stream_force_ssl_enabled: response?.Storage_setting?.bunnyCdn_stream_force_ssl_enabled || false,
            bunny_cdn_frontend_asset_enabled: response?.Storage_setting?.bunnyCdn_frontendAssetEnabled || response?.Storage_setting?.bunny_cdn_frontend_asset_enabled || 0,
            bunny_cdn_frontend_asset_url: response?.Storage_setting?.bunnyCdn_frontendAssetUrl || response?.Storage_setting?.bunny_cdn_frontend_asset_url || response?.Storage_setting?.frontend_asset_cdn_url || '',
            // Stream Token Authentication
            bunny_cdn_stream_token_auth_enabled: response?.Storage_setting?.bunnyCdn_streamTokenAuthEnabled || 0,
            bunny_cdn_stream_token_auth_key: response?.Storage_setting?.bunnyCdn_streamTokenAuthKey || '',
            bunny_cdn_stream_token_auth_ttl: response?.Storage_setting?.bunnyCdn_streamTokenAuthTTL || 3600,
            bunny_cdn_stream_token_auth_ip_restrict: response?.Storage_setting?.bunnyCdn_streamTokenAuthIpRestrict || 0,
            // Storage Token Authentication
            bunny_cdn_storage_token_auth_enabled: response?.Storage_setting?.bunnyCdn_storageTokenAuthEnabled || 0,
            bunny_cdn_storage_token_auth_key: response?.Storage_setting?.bunnyCdn_storageTokenAuthKey || '',
            bunny_cdn_storage_token_auth_ttl: response?.Storage_setting?.bunnyCdn_storageTokenAuthTTL || 3600,
            bunny_cdn_storage_token_auth_ip_restrict: response?.Storage_setting?.bunnyCdn_storageTokenAuthIpRestrict || 0,
            aws_video_bucket: response?.Storage_setting?.aws_video_bucket || '',
            aws_audio_bucket: response?.Storage_setting?.aws_audio_bucket || '',
            aws_image_dir: response?.Storage_setting?.aws_image_dir || 'uploads',
            aws_inputVideoDir: response?.Storage_setting?.aws_inputVideoDir || 'uploads/videos',
            aws_ouputVideoDir: response?.Storage_setting?.aws_ouputVideoDir || 'uploads/streams',
            aws_audio_dir: response?.Storage_setting?.aws_audio_dir || 'uploads/audios',
            aws_video_cloudfront_domain: response?.Storage_setting?.aws_video_cloudfront_domain || '',
            aws_audio_cloudfront_domain: response?.Storage_setting?.aws_audio_cloudfront_domain || '',
            aws_stream_cloudfront_domain: response?.Storage_setting?.aws_stream_cloudfront_domain || '',
            aws_cloudfront_signed_urls_enabled: response?.Storage_setting?.aws_cloudfront_signed_urls_enabled || 0,
            aws_cloudfront_key_pair_id: response?.Storage_setting?.aws_cloudfront_key_pair_id || '',
            aws_cloudfront_signed_url_ttl: response?.Storage_setting?.aws_cloudfront_signed_url_ttl || 21600,
            storageMemory: [...response?.storageMemory],
            transcoding_resolution: multiSelectLabel(response?.transcoding_resolution, 'value', 'name'),
          }))
          checkCfKeyStatus();
        }
      }).catch((error => {
        toast.error(error?.response?.data?.message || error.message)
      })).finally(() => {
        setLoading(false)
      })

  }, [withOutRefresh, location]);


  if (loading) {
    return <Defaultloadinggif className={"heightOnLoader"} />
  }


  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader loading={showOverlay} heading={labelDisplay?.[0]?.title} saveText={"Update Settings"} saveMethod={handleAction} />
      {showModal && <AdminSliderModal modalHeading={`Switching to ${activeStorage?.replace(/_/g, ' ')}`} modalDescription={`Others Storage will be disabled. Do you want to proceed?`} modelClose={showModal} sliderClose={closeModal} sliderAction={confirmToggle} />}
      {sslModalConfig && (
        <AdminSliderModal
          modalHeading={`${sslModalConfig.checked ? 'Enable' : 'Disable'} ${sslModalConfig.name === 'bunny_cdn_stream_ssl_enabled' ? 'SSL' : 'Force SSL'}`}
          modalDescription={`Are you sure you want to ${sslModalConfig.checked ? 'enable' : 'disable'} this setting on CDN?`}
          modelClose={!!sslModalConfig}
          sliderClose={() => setSslModalConfig(null)}
          sliderAction={confirmSslToggle}
        />
      )}
      <div className="d-flex align-items-center flex-wrap mb-4">
        <div className="col-12 col-md-6 col-lg-6 col-xl-4 py-3 pe-3">
          <div className=" rounded-3  d-flex align-items-center  theme-bg-color justify-content-between p-4">
            <MessageLabel text={"Site Storage"} noMargin />
            <AdminSwitch name={'site_storage'} checked={formData?.site_storage == 1} onChange={handleInput} />
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-6 col-xl-4  p-3">
          <div className=" rounded-3  d-flex align-items-center  theme-bg-color justify-content-between p-4">
            <MessageLabel text={"Enable AWS Storage"} noMargin />
            <AdminSwitch name={'aws_storage'} checked={formData?.aws_storage == 1} onChange={handleInput} />
          </div>
        </div>
        {/* <div className="col-12 col-md-6 col-lg-6 col-xl-4 py-3 ps-3">
          <div className=" rounded-3  d-flex align-items-center  theme-bg-color justify-content-between p-4">
            <MessageLabel text={"Enable SFTP"} noMargin />
            <AdminSwitch name={'sftp_storage'} checked={formData?.sftp_storage == 1} onChange={handleInput} />
          </div>
        </div> */}
        <div className="col-12 col-md-6 col-lg-6 col-xl-4 py-3 ps-3">
          <div className=" rounded-3  d-flex align-items-center  theme-bg-color justify-content-between p-4">
            <MessageLabel text={"CDN Storage"} noMargin />
            <AdminSwitch name={'bunny_cdn_storage'} checked={formData?.bunny_cdn_storage == 1} onChange={handleInput} />
          </div>
        </div>
        {/* <div className="col-12 col-md-6 col-lg-6 col-xl-4 py-3 pe-3">
          <div className=" rounded-3  d-flex align-items-center  theme-bg-color justify-content-between p-4">
            <MessageLabel text={"Flussonic CDN Storage"} noMargin />
            <AdminSwitch name={'flussonic_storage'} checked={formData?.flussonic_storage == 1} onChange={handleInput} />
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-6 col-xl-4 p-3">
          <div className=" rounded-3  d-flex align-items-center  theme-bg-color justify-content-between p-4">
            <MessageLabel text={"Videocipher CDN Storage"} noMargin />
            <AdminSwitch name={'videocipher_storage'} checked={formData?.videocipher_storage == 1} onChange={handleInput} />
          </div>
        </div> */}
        <div className="col-12 col-md-6 col-lg-6 col-xl-4 py-3 ps-3">
          <div className=" rounded-3  d-flex align-items-center  theme-bg-color justify-content-between p-4">
            <MessageLabel text={"Enable Brightcove"} noMargin />
            <AdminSwitch name={'brightcove_storage'} checked={formData?.brightcove_storage == 1} onChange={handleInput} />
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-6 col-xl-4 py-3 pe-3">
          <div className=" rounded-3  d-flex align-items-center  theme-bg-color justify-content-between p-4">
            <MessageLabel text={"Google Cloud Storage"} noMargin />
            <AdminSwitch name={'gcs_storage'} checked={formData?.gcs_storage == 1} onChange={handleInput} />
          </div>
        </div>
      </div>

      {/* Transcoding Settings Navigation */}
      <div className="mb-4">
        <div className="row">
          <div className="col-12">
            <div className="theme-bg-color rounded-3 p-4 position-relative overflow-hidden"
              style={{ border: '1px solid rgba(0,123,255,0.15)', background: 'linear-gradient(135deg, rgba(0,123,255,0.02) 0%, rgba(0,123,255,0.06) 100%)' }}>

              {/* Background decorative element */}
              <div className="position-absolute"
                style={{
                  top: '-20px',
                  right: '-20px',
                  width: '80px',
                  height: '80px',
                  background: 'rgba(0,123,255,0.05)',
                  borderRadius: '50%'
                }}></div>

              <div className="d-flex align-items-center justify-content-between position-relative">
                <div className="d-flex align-items-center">
                  {/* Icon container */}
                  <div className="me-3 p-2 rounded-circle"
                    style={{ background: 'rgba(0,123,255,0.1)' }}>
                    <svg width="20" height="20" fill="#007bff" viewBox="0 0 16 16">
                      <path d="M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                      <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                    </svg>
                  </div>

                  <div>
                    <h6 className="mb-1 theme-text-color fw-semibold d-flex align-items-center">
                      Transcoding Configuration
                      <span className="badge bg-primary ms-2 px-2 py-1" style={{ fontSize: '10px' }}>Advanced</span>
                    </h6>
                    <small className="text-muted d-block">Configure video processing, quality settings and encoding options</small>
                    <div className="mt-2">
                      <span className="badge bg-light text-dark me-1 px-2 py-1" style={{ fontSize: '10px' }}>Video Quality</span>
                      <span className="badge bg-light text-dark me-1 px-2 py-1" style={{ fontSize: '10px' }}>Encoding</span>
                      <span className="badge bg-light text-dark px-2 py-1" style={{ fontSize: '10px' }}>Resolution</span>
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-column align-items-end">
                  <a
                    href="/site/transcoding-setting"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary btn-sm d-flex align-items-center px-3 py-2 mb-2 shadow-sm"
                    style={{
                      fontSize: '13px',
                      fontWeight: '500',
                      transition: 'all 0.2s ease-in-out',
                      border: '1px solid #007bff',
                      textDecoration: 'none',
                      color: 'inherit'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-1px)';
                      e.target.style.boxShadow = '0 4px 12px rgba(0,123,255,0.25)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }}
                  >
                    <svg width="14" height="14" fill="currentColor" className="me-2" viewBox="0 0 16 16">
                      <path d="M11.354 4.646a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 5 4.646 5a.5.5 0 0 1 0-1h6.5a.5.5 0 0 1 .354.146z" />
                      <path d="M11.5 4a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V5.707l-5.646 5.647a.5.5 0 0 1-.708-.708L10.293 5H4.5a.5.5 0 0 1 0-1h6.5z" />
                    </svg>
                    Configure
                  </a>
                  <small className="text-muted" style={{ fontSize: '11px' }}>
                    Click to manage settings
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Wrapper>
        <MessageHeading text="Storage Upload Limit" />
        <div className="row g-3 align-items-end">
          <div className="col-md-6">
            <MessageLabel text="Maximum Upload Size" />
            <AdminCustomInput
              id="storageLimit"
              type="number"
              name="site_storage_limit"
              min={0}
              value={formData?.site_storage_limit}
              onChange={handleInput}
              placeHolder="Site storage limit"
              ref={(el) => (combinedRef.current.site_storage_limit = el)}
              error={formDataError?.site_storage_limit}
            />
          </div>
          <div className="col-md-6">
            <MessageLabel text="Storage Unit" />
            <AdminCustomSelect
              id="storageType"
              name="site_storage_memory"
              value={formData?.site_storage_memory}
              onChange={handleInput}
              ref={(el) => (combinedRef.current.site_storage_memory = el)}
              options={formData?.storageMemory?.map((item) => ({
                name: item?.label,
                value: item?.value,
              }))}
              error={formDataError?.site_storage_memory}
            />
          </div>
        </div>
      </Wrapper>

      <FormContainer>
        {formData?.site_storage === 1 ?
          <>
            {/* <LeftWrapper >
              <Wrapper>
                <MessageHeading text="Create Site Storage Details" />
                <MessageLabel text={"Site KEY"} className="" />
                <AdminCustomInput type="text" name="site_key" value={formData?.site_key} onChange={handleInput} placeHolder={"site key"} ref={(el) => (combinedRef.current.site_key = el)} error={formDataError?.site_key} />
                <MessageLabel text={"Site Action Ex:(list) "} className="" />
                <AdminCustomInput type="text" name="site_action" value={formData?.site_action} onChange={handleInput} placeHolder={"site action"} ref={(el) => (combinedRef.current.site_action = el)} error={formDataError?.site_action} />
              </Wrapper >
            </LeftWrapper > */}
            {/* <RightWrapper>
              <Wrapper>
                <MessageHeading text="Other Details" />
                <MessageLabel text={"Site User"} className="" />
                <AdminCustomInput type="text" name="site_user" value={formData?.site_user} onChange={handleInput} placeHolder={"site user"} ref={(el) => (combinedRef.current.site_user = el)} error={formDataError?.site_user} />
                <MessageLabel text={"Site Server IP"} className="" />
                <AdminCustomInput type="text" name="site_IPSERVERAPI" value={formData?.site_IPSERVERAPI} onChange={handleInput} placeHolder={"site ip"} ref={(el) => (combinedRef.current.site_IPSERVERAPI = el)} error={formDataError?.site_IPSERVERAPI} />
              </Wrapper>
            </RightWrapper> */}
          </>
          : ""}
        {formData?.bunny_cdn_storage === 1 ?
          <>
            <LeftWrapper >
              <Wrapper>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <MessageHeading text="Storage Configuration" noMargin />
                </div>

                <div className="bg-light-soft p-3 rounded mb-4 border-dashed">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="me-3">
                      <div className="d-flex align-items-center mb-1">
                        <h6 className="mb-0 fw-bold">One-Click Provisioning</h6>
                        {formData?.bunny_cdn_access_key && (
                          <span className="badge bg-success-subtle text-success border border-success-subtle ms-2 py-1 px-2 rounded-pill" style={{ fontSize: '0.7rem' }}>
                            <i className="fa fa-check-circle me-1"></i> Active
                          </span>
                        )}
                      </div>
                      <small className="text-muted d-block mb-2">Generate a new storage zone with optimized settings for your platform.</small>
                    </div>
                    <AdminCustomButton
                      className={`px-4 shadow-sm ${storageGenerating ? 'btn-secondary' : 'btn-primary'}`}
                      saveText={storageGenerating ?
                        <span><i className="fa fa-spinner fa-spin me-2"></i>Provisioning...</span> :
                        <span><i className="fa fa-bolt me-2"></i>Generate Storage Zone</span>
                      }
                      saveMethod={generateStorage}
                      loading={storageGenerating}
                    />
                  </div>
                </div>

                <FormContainer className="mb-3">
                  <div className="col-4">
                    <MessageLabel text={"Region"} noMargin />
                    <AdminCustomInput type="text" name="bunny_cdn_region" value={formData?.bunny_cdn_region} onChange={handleInput} placeHolder={"Enter region code"} ref={(el) => (combinedRef.current.bunny_cdn_region = el)} error={formDataError?.bunny_cdn_region} />
                  </div>
                  <div className="col-4 px-2">
                    <MessageLabel text={"Connection Type"} noMargin />
                    <AdminCustomInput type="text" name="bunny_cdn_storage_connection_type" value={formData?.bunny_cdn_storage_connection_type} onChange={handleInput} placeHolder={"e.g., ftp, sftp"} ref={(el) => (combinedRef.current.bunny_cdn_storage_connection_type = el)} error={formDataError?.bunny_cdn_storage_connection_type} />
                  </div>
                  <div className="col-4">
                    <MessageLabel text={"Storage Port"} noMargin />
                    <AdminCustomInput type="text" name="bunny_cdn_storage_port" value={formData?.bunny_cdn_storage_port || '21'} onChange={handleInput} placeHolder={"Default: 21"} ref={(el) => (combinedRef.current.bunny_cdn_storage_port = el)} error={formDataError?.bunny_cdn_storage_port} />
                  </div>
                </FormContainer>
                <MessageLabel text={"Storage Zone Name"} className="" />
                <AdminCustomInput type="text" name="bunny_cdn_storage_zone_name" value={formData?.bunny_cdn_storage_zone_name} onChange={handleInput} placeHolder={"Enter storage zone name"} ref={(el) => (combinedRef.current.bunny_cdn_storage_zone_name = el)} error={formDataError?.bunny_cdn_storage_zone_name} />
                <MessageLabel text={" Hostname"} className="" />
                <AdminCustomInput type="text" name="bunny_cdn_storage_host_name" value={formData?.bunny_cdn_storage_host_name} onChange={handleInput} placeHolder={"Enter storage hostname (e.g., storage.cdn.com)"} ref={(el) => (combinedRef.current.bunny_cdn_storage_host_name = el)} error={formDataError?.bunny_cdn_storage_host_name} />
                <MessageLabel text={" Access Key"} className="" />
                <AdminCustomPasswordInput name="bunny_cdn_access_key" value={formData?.bunny_cdn_access_key} onChange={handleInput} placeHolder={"Enter storage access key"} ref={(el) => (combinedRef.current.bunny_cdn_access_key = el)} error={formDataError?.bunny_cdn_access_key} />
                <MessageLabel text={"CDN Linked Hostname"} className="" />
                <AdminCustomInput type="text" name="bunny_cdn_cdn_linked_host_name" value={formData?.bunny_cdn_cdn_linked_host_name} onChange={handleInput} placeHolder={"Enter CDN linked hostname"} ref={(el) => (combinedRef.current.bunny_cdn_cdn_linked_host_name = el)} error={formDataError?.bunny_cdn_cdn_linked_host_name} />
                <div className="d-flex align-items-center gap-3 mt-3">
                  <MessageLabel text={"Enable SSL"} noMargin />
                  <AdminSwitch name={'bunny_cdn_storage_ssl_enabled'} checked={formData?.bunny_cdn_storage_ssl_enabled == 1} onChange={(e) => handleSslToggle(e.target.name, e.target.checked)} />
                  <MessageLabel text={"Force SSL"} noMargin />
                  <AdminSwitch name={'bunny_cdn_storage_force_ssl_enabled'} checked={formData?.bunny_cdn_storage_force_ssl_enabled == 1} onChange={(e) => handleSslToggle(e.target.name, e.target.checked)} />
                </div>
              </Wrapper >

              <Wrapper>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <MessageHeading text="Frontend CDN Configuration" noMargin />
                </div>
                <div className="bg-light-soft px-3 ">
                  <div className="flex-wrap gap-3">

                    <div className="d-flex align-items-center justify-content-between gap-3 mt-3">
                      <MessageLabel text={"Enable CDN"} noMargin />
                      <AdminSwitch name={'bunny_cdn_frontend_asset_enabled'} checked={formData?.bunny_cdn_frontend_asset_enabled == 1} onChange={handleInput} />
                    </div>
                    {formData?.bunny_cdn_frontend_asset_enabled == 1 && (
                      <>
                        <MessageLabel text={"CDN Linked Hostname"} className="mt-3" />
                        <AdminCustomInput type="text" name="bunny_cdn_frontend_asset_url" value={formData?.bunny_cdn_frontend_asset_url} onChange={handleInput} placeHolder={"https://cdn.yourdomain.com"} ref={(el) => (combinedRef.current.bunny_cdn_frontend_asset_url = el)} error={formDataError?.bunny_cdn_frontend_asset_url} />
                        <MessageBox text={"files: /static/js, /static/css, and /static/media. Keep index.html and runtime-config.js on the main domain."} classname="text-muted mb-3 d-block" />
                      </>
                    )}
                  </div>
                </div>
              </Wrapper>

              <Wrapper>
                <MessageHeading text="Directory Settings" />
                <MessageLabel text={"Image/Assets Directory"} className="" />
                <MessageBox
                  text={`Storage Path Structure — Images: ${formData?.bunny_cdn_image_dir || 'dir'}/images, Assets: ${formData?.bunny_cdn_image_dir || 'dir'}/subtitles, ${formData?.bunny_cdn_image_dir || 'dir'}/advertisement etc.`}
                  classname="text-muted mb-3 d-block"
                />
                <AdminCustomInput type="text" name="bunny_cdn_image_dir" value={formData?.bunny_cdn_image_dir || 'uploads'} onChange={handleInput} placeHolder={"Enter image directory name (Ex:uploads)"} ref={(el) => (combinedRef.current.bunny_cdn_image_dir = el)} error={formDataError?.bunny_cdn_image_dir} />
                <MessageLabel text={"Video Directory"} className="" />
                <AdminCustomInput type="text" name="bunny_cdn_video_dir" value={formData?.bunny_cdn_video_dir || 'uploads/videos'} onChange={handleInput} placeHolder={"Enter video directory name (Ex:uploads/videos)"} ref={(el) => (combinedRef.current.bunny_cdn_video_dir = el)} error={formDataError?.bunny_cdn_video_dir} />
                <MessageLabel text={"Audio Directory"} className="" />
                <AdminCustomInput type="text" name="bunny_cdn_audio_dir" value={formData?.bunny_cdn_audio_dir || 'uploads/audios'} onChange={handleInput} placeHolder={"Enter audio directory name (Ex:uploads/audios)"} ref={(el) => (combinedRef.current.bunny_cdn_audio_dir = el)} error={formDataError?.bunny_cdn_audio_dir} />
              </Wrapper >

              <Wrapper>
                <MessageHeading text="CDN Configuration" />
                <MessageLabel text={"Origin Pull Zone Name"} className="" />
                <AdminCustomInput type="text" name="bunny_cdn_origin_pull_zone_name" value={formData?.bunny_cdn_origin_pull_zone_name} onChange={handleInput} placeHolder={"Enter origin pull zone name"} ref={(el) => (combinedRef.current.bunny_cdn_origin_pull_zone_name = el)} error={formDataError?.bunny_cdn_origin_pull_zone_name} />
              </Wrapper>

              <Wrapper>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <MessageHeading text="Sync Local Assets to CDN" noMargin />
                </div>
                <div className="bg-light-soft p-3 rounded border-dashed">
                  <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                    <div className="me-3">
                      <div className="d-flex align-items-center mb-1">
                        <h6 className="mb-0 fw-bold">Push existing files to CDN Storage</h6>
                      </div>
                      <small className="text-muted d-block">
                        Browse your server's <code>uploads/</code> directory and select files or whole
                        folders. The original folder structure is preserved 1:1 on CDN.
                      </small>
                    </div>
                    <AdminCustomButton
                      className="px-4 shadow-sm btn-primary"
                      saveText={<span><i className="fa fa-cloud-upload-alt me-2"></i>Sync to CDN</span>}
                      saveMethod={() => {
                        if (!formData?.bunny_cdn_access_key || !formData?.bunny_cdn_storage_host_name || !formData?.bunny_cdn_storage_zone_name) {
                          toast.error("Please configure CDN Access Key, Hostname, and Storage Zone Name first.");
                          return;
                        }
                        setShowBunnySyncModal(true);
                      }}
                    />
                  </div>
                </div>
              </Wrapper>

            </LeftWrapper >
            <RightWrapper>
              <Wrapper>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <MessageHeading text="Stream Configuration" noMargin />
                </div>

                <div className="bg-light-soft p-3 rounded mb-4 border-dashed">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="me-3">
                      <div className="d-flex align-items-center mb-1">
                        <h6 className="mb-0 fw-bold"> Stream Library</h6>
                        {formData?.bunny_cdn_stream_access_key && (
                          <span className="badge bg-success-subtle text-success border border-success-subtle ms-2 py-1 px-2 rounded-pill" style={{ fontSize: '0.7rem' }}>
                            <i className="fa fa-check-circle me-1"></i> Provisioned
                          </span>
                        )}
                      </div>
                      <small className="text-muted d-block mb-2">Provision a dedicated transcoding and streaming library.</small>
                    </div>

                    <AdminCustomButton
                      className={`px-4 shadow-sm ${streamGenerating ? 'btn-secondary' : 'btn-primary'}`}
                      saveText={streamGenerating ?
                        <span><i className="fa fa-spinner fa-spin me-2"></i>Provisioning...</span> :
                        <span><i className="fa fa-bolt me-2"></i>Generate Stream Library</span>
                      }
                      saveMethod={generateStream}
                      loading={streamGenerating}
                    />
                  </div>
                </div>
                <MessageLabel text={" Access Key"} className="" />
                <AdminCustomPasswordInput name="bunny_cdn_stream_access_key" value={formData?.bunny_cdn_stream_access_key} onChange={handleInput} placeHolder={"Enter stream access key"} ref={(el) => (combinedRef.current.bunny_cdn_stream_access_key = el)} error={formDataError?.bunny_cdn_stream_access_key} />
                <MessageLabel text={" Library ID"} className="" />
                <AdminCustomInput type="text" name="bunny_cdn_stream_library_id" value={formData?.bunny_cdn_stream_library_id} onChange={handleInput} placeHolder={"Enter stream library ID"} ref={(el) => (combinedRef.current.bunny_cdn_stream_library_id = el)} error={formDataError?.bunny_cdn_stream_library_id} />
                <MessageLabel text={" CDN Linked Hostname"} className="" />
                <AdminCustomInput type="text" name="bunny_cdn_stream_cdn_host_name" value={formData?.bunny_cdn_stream_cdn_host_name} onChange={handleInput} placeHolder={"Enter stream CDN hostname"} ref={(el) => (combinedRef.current.bunny_cdn_stream_cdn_host_name = el)} error={formDataError?.bunny_cdn_stream_cdn_host_name} />
                <MessageLabel text={" Webhook URL"} className="" />
                <AdminCustomPasswordInput isReadonly={true} name="bunny_cdn_stream_webhook_url" value={`${baseURL}/admin/library/bunnycdn-stream-webhook`} placeHolder={"Webhook URL"} ref={(el) => (combinedRef.current.bunny_cdn_stream_webhook_url = el)} />

                <div className="d-flex align-items-center gap-3">
                  <MessageLabel text={"Enable SSL"} noMargin />
                  <AdminSwitch name={'bunny_cdn_stream_ssl_enabled'} checked={formData?.bunny_cdn_stream_ssl_enabled == 1} onChange={(e) => handleSslToggle(e.target.name, e.target.checked)} />
                  <MessageLabel text={"Force SSL"} noMargin />
                  <AdminSwitch name={'bunny_cdn_stream_force_ssl_enabled'} checked={formData?.bunny_cdn_stream_force_ssl_enabled == 1} onChange={(e) => handleSslToggle(e.target.name, e.target.checked)} />
                </div>
              </Wrapper>



              <Wrapper>
                <MessageHeading text="Token Authentication" />

                {/* ── Stream ─────────────────────────────────────────────────────── */}
                <MessageHeading text="Stream" noMargin />

                <div className="bg-light-soft p-3 rounded my-3 border-dashed">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="me-3">
                      <div className="d-flex align-items-center mb-1">
                        <MessageLabel text="Token Authentication Key" noMargin />
                        {formData?.bunny_cdn_stream_token_auth_key && (
                          <span className="badge bg-success-subtle text-success border border-success-subtle ms-2 py-1 px-2 rounded-pill" style={{ fontSize: '0.7rem' }}>
                            <i className="fa fa-check-circle me-1"></i> Synced
                          </span>
                        )}
                      </div>
                      <small className="text-muted d-block">Fetch and sync your token authentication key directly from Stream CDN.</small>
                    </div>
                    <AdminCustomButton
                      className={`px-4 shadow-sm ${fetchingTokenKey ? 'btn-secondary' : 'btn-primary'}`}
                      saveText={fetchingTokenKey
                        ? <span><i className="fa fa-spinner fa-spin me-2"></i>Fetching...</span>
                        : <span><i className="fa fa-bolt me-2"></i>Fetch from CDN</span>}
                      saveMethod={handleFetchStreamTokenKey}
                      loading={fetchingTokenKey}
                    />
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between gap-3 py-3 mb-3">
                  <MessageLabel text="CDN Token Authentication" noMargin />
                  {togglingCdnAuth
                    ? <span className="spinner-border spinner-border-sm text-primary" />
                    : <AdminSwitch
                      name="bunny_cdn_stream_token_auth_enabled"
                      checked={formData?.bunny_cdn_stream_token_auth_enabled == 1}
                      onChange={(e) => handleTokenAuthToggle(e.target.checked)}
                    />
                  }
                </div>

                {formData?.bunny_cdn_stream_token_auth_enabled == 1 && (
                  <>
                    <MessageLabel text="Token Authentication Key" />
                    <AdminCustomPasswordInput
                      isReadonly
                      name="bunny_cdn_stream_token_auth_key"
                      value={formData?.bunny_cdn_stream_token_auth_key}
                      onChange={handleInput}
                      placeHolder="Click 'Fetch from CDN' to auto-load"
                      ref={(el) => (combinedRef.current.bunny_cdn_stream_token_auth_key = el)}
                      error={formDataError?.bunny_cdn_stream_token_auth_key}
                    />
                    <div className="d-flex align-items-center justify-content-between gap-3 py-2 mt-2">
                      <div>
                        <MessageLabel text="IP Restriction" noMargin />
                        <small className="text-muted d-block">Optional. Only recommended for web-only deployments with no mobile users — mobile users change IPs (WiFi ↔ 4G) and will lose playback mid-stream.</small>
                      </div>
                      <AdminSwitch
                        name="bunny_cdn_stream_token_auth_ip_restrict"
                        checked={formData?.bunny_cdn_stream_token_auth_ip_restrict == 1}
                        onChange={handleInput}
                      />
                    </div>
                  </>
                )}

                {/* ── Storage ────────────────────────────────────────────────────── */}
                <MessageHeading text="Storage" noMargin />

                <div className="bg-light-soft p-3 rounded my-3 border-dashed">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="me-3">
                      <div className="d-flex align-items-center mb-1">
                        <MessageLabel text="Zone Security Key" noMargin />
                        {formData?.bunny_cdn_storage_token_auth_key && (
                          <span className="badge bg-success-subtle text-success border border-success-subtle ms-2 py-1 px-2 rounded-pill" style={{ fontSize: '0.7rem' }}>
                            <i className="fa fa-check-circle me-1"></i> Synced
                          </span>
                        )}
                      </div>
                      <small className="text-muted d-block">Fetch from your Storage CDN pull zone. Protects video &amp; audio files only.</small>
                    </div>
                    <AdminCustomButton
                      className={`px-4 shadow-sm ${fetchingStorageTokenKey ? 'btn-secondary' : 'btn-primary'}`}
                      saveText={fetchingStorageTokenKey
                        ? <span><i className="fa fa-spinner fa-spin me-2"></i>Fetching...</span>
                        : <span><i className="fa fa-bolt me-2"></i>Fetch from CDN</span>}
                      saveMethod={handleFetchStorageTokenKey}
                      loading={fetchingStorageTokenKey}
                    />
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between gap-3 py-2 mb-3">
                  <MessageLabel text="Enable Token Auth" noMargin />
                  {togglingStorageCdnAuth
                    ? <span className="spinner-border spinner-border-sm text-primary" />
                    : <AdminSwitch
                        name="bunny_cdn_storage_token_auth_enabled"
                        checked={formData?.bunny_cdn_storage_token_auth_enabled == 1}
                        onChange={(e) => handleStorageTokenAuthToggle(e.target.checked)}
                      />
                  }
                </div>

                {formData?.bunny_cdn_storage_token_auth_enabled == 1 && (
                  <>
                    <MessageLabel text="Token Authentication Key" />
                    <AdminCustomPasswordInput
                      name="bunny_cdn_storage_token_auth_key"
                      value={formData?.bunny_cdn_storage_token_auth_key}
                      onChange={handleInput}
                      placeHolder="Paste key or click 'Fetch from CDN'"
                      ref={(el) => (combinedRef.current.bunny_cdn_storage_token_auth_key = el)}
                      error={formDataError?.bunny_cdn_storage_token_auth_key}
                    />
                    <div className="d-flex align-items-center justify-content-between gap-3 py-2 mt-2">
                      <div>
                        <MessageLabel text="IP Restriction" noMargin />
                        <small className="text-muted d-block">Optional. Only recommended for web-only deployments with no mobile users — mobile users change IPs (WiFi ↔ 4G) and will lose playback mid-stream.</small>
                      </div>
                      <AdminSwitch
                        name="bunny_cdn_storage_token_auth_ip_restrict"
                        checked={formData?.bunny_cdn_storage_token_auth_ip_restrict == 1}
                        onChange={handleInput}
                      />
                    </div>
                  </>
                )}

                {/* ── Common TTL ── */}
                <MessageLabel text="Token TTL (seconds)" />
                <AdminCustomInput
                  type="number"
                  name="bunny_cdn_stream_token_auth_ttl"
                  value={formData?.bunny_cdn_stream_token_auth_ttl}
                  onChange={handleCommonTTL}
                  placeHolder="3600"
                  ref={(el) => (combinedRef.current.bunny_cdn_stream_token_auth_ttl = el)}
                  error={formDataError?.bunny_cdn_stream_token_auth_ttl}
                />

                {/* ── Test both ── */}
                <div className="mt-3">
                  <AdminCustomButton
                    className="btn-outline-primary btn-sm"
                    saveMethod={handleTestBothTokenAuth}
                    loading={tokenAuthTestLoading}
                    saveText="Test Token Auth"
                  />

                  {tokenAuthTestResult && (
                    <div className={`mt-2 p-2 rounded small ${tokenAuthTestResult.status ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                      <strong>Stream CDN — {tokenAuthTestResult.status ? '✅ Working' : '❌ Not working'}</strong>
                      {' '}{tokenAuthTestResult.detail}
                      {tokenAuthTestResult.signedUrl && (
                        <div className="mt-1">
                          <a href={tokenAuthTestResult.signedUrl} target="_blank" rel="noreferrer" className="text-break small">View signed probe URL</a>
                          <span className="ms-2 text-muted">Expires: {tokenAuthTestResult.expiresAt}</span>
                        </div>
                      )}
                    </div>
                  )}

                  {storageTokenAuthTestResult && (
                    <div className={`mt-2 p-2 rounded small ${storageTokenAuthTestResult.status ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                      <strong>Storage CDN — {storageTokenAuthTestResult.status ? '✅ Working' : '❌ Not working'}</strong>
                      {' '}{storageTokenAuthTestResult.detail}
                      {storageTokenAuthTestResult.liveKeyMatch !== null && storageTokenAuthTestResult.liveKeyMatch !== undefined && (
                        <span className="ms-2 text-muted">
                          | Live key: <strong>{storageTokenAuthTestResult.liveKeyMatch ? '✅ Match' : '❌ Mismatch'}</strong>
                        </span>
                      )}
                      {storageTokenAuthTestResult.signedUrl && (
                        <div className="mt-1">
                          <a href={storageTokenAuthTestResult.signedUrl} target="_blank" rel="noreferrer" className="text-break small">View signed probe URL</a>
                          <span className="ms-2 text-muted">Expires: {storageTokenAuthTestResult.expiresAt}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Wrapper>

              <Wrapper>
                <MessageHeading text="Global API Configuration" />
                <MessageLabel text={"Global Access Key"} className="" />
                <AdminCustomPasswordInput name="bunny_cdn_global_access_key" value={formData?.bunny_cdn_global_access_key} onChange={handleInput} placeHolder={"Enter CDN global access key"} ref={(el) => (combinedRef.current.bunny_cdn_global_access_key = el)} error={formDataError?.bunny_cdn_global_access_key} />
              </Wrapper>
            </RightWrapper>

          </>
          : ""}
        {formData?.videocipher_storage === 1 ?
          <>
            <LeftWrapper >
              <Wrapper>
                <MessageHeading text="Config VideoCipher ApiKey Details" />
                <MessageLabel text={"VideoCipher ApiKey"} className="" />
                <AdminCustomInput type="text" name="videocipher_ApiKey" value={formData?.videocipher_ApiKey} onChange={handleInput} placeHolder={placeHolder('Enter videocipher api key')} ref={(el) => (combinedRef.current.videocipher_ApiKey = el)} error={formDataError?.videocipher_ApiKey} />
                <MessageLabel text={"VideoCipher PPV Resolution"} className="" />
                <Select ref={(el) => (combinedRef.current.videocipher_PPV_Resolution = el)} options={formData?.transcoding_resolution} isMulti name={'videocipher_PPV_Resolution'} onChange={handleMultiSelect} value={formData?.videocipher_PPV_Resolution} className={`${formDataError?.videocipher_PPV_Resolution && 'custom-input-error'} custom-select-multi custom-placeholder theme-text-color mb-3`} />
                {formDataError?.videocipher_PPV_Resolution && (<MessageBox text={`${formDataError?.videocipher_PPV_Resolution}`} classname='errorred mb-2 d-block' />)}
              </Wrapper >
            </LeftWrapper >
          </> : ""}
        {formData?.flussonic_storage === 1 ?
          <>
            <LeftWrapper >
              <Wrapper>
                <MessageHeading text="Config Flussonic Storage Details" />
                <MessageLabel text={"Flussonic Storage Server Base URL"} className="" />
                <AdminCustomInput type="text" name="flussonic_storage_site_base_url" value={formData?.flussonic_storage_site_base_url} onChange={handleInput} placeHolder={placeHolder('Enter flussonic storage site base url')} ref={(el) => (combinedRef.current.flussonic_storage_site_base_url = el)} error={formDataError?.flussonic_storage_site_base_url} />
                <MessageLabel text={"Flussonic Storage UserName"} className="" />
                <AdminCustomInput type="text" name="flussonic_storage_username" value={formData?.flussonic_storage_username} onChange={handleInput} placeHolder={"Enter flussonic storage username"} ref={(el) => (combinedRef.current.flussonic_storage_username = el)} error={formDataError?.flussonic_storage_username} />
                <MessageLabel text={"Flussonic Storage Password"} className="" />
                <AdminCustomInput type="text" name="flussonic_storage_password" value={formData?.flussonic_storage_password} onChange={handleInput} placeHolder={"Enter flussonic storage password"} ref={(el) => (combinedRef.current.flussonic_storage_password = el)} error={formDataError?.flussonic_storage_password} />
              </Wrapper >
            </LeftWrapper >
            <RightWrapper>
              <Wrapper>
                <MessageHeading text="Other Details" />
                <MessageLabel text={"Flussonic Storage Tag"} className="" />
                <AdminCustomInput type="text" name="flussonic_storage_tag" value={formData?.flussonic_storage_tag} onChange={handleInput} placeHolder={"Enter flussonic storage tag"} ref={(el) => (combinedRef.current.flussonic_storage_tag = el)} error={formDataError?.flussonic_storage_tag} />
              </Wrapper>
            </RightWrapper>
          </>
          : ""}

        {formData?.sftp_storage === 1 ?
          <>
            <LeftWrapper >
              <Wrapper>
                <MessageHeading text="Config SFTP Storage Details" />
                <MessageLabel text={"Domain URL"} className="" />
                <AdminCustomInput
                  type="text"
                  name="domain_url"
                  value={formData?.domain_url}
                  onChange={handleInput}
                  placeHolder="https://api.example.com"
                  ref={(el) => (combinedRef.current.domain_url = el)}
                  error={formDataError?.domain_url}
                />
                <MessageLabel text={"SFTP Storage Host"} className="" />
                <AdminCustomInput type="text" name="sftp_host" value={formData?.sftp_host} onChange={handleInput} placeHolder={placeHolder('Enter SFTP storage host')} ref={(el) => (combinedRef.current.sftp_host = el)} error={formDataError?.sftp_host} />
                <MessageLabel text={"SFTP Storage Port"} className="" />
                <AdminCustomInput type="number" name="sftp_port" value={formData?.sftp_port} onChange={handleInput} placeHolder={"Enter SFTP storage port (1-65535)"} min="1" max="65535" ref={(el) => (combinedRef.current.sftp_port = el)} error={formDataError?.sftp_port} />
              </Wrapper >
            </LeftWrapper >
            <RightWrapper>
              <Wrapper>
                <MessageLabel text={"SFTP Storage Username"} className="" />
                <AdminCustomInput type="text" name="sftp_username" value={formData?.sftp_username} onChange={handleInput} placeHolder={"Enter SFTP Storage Username"} ref={(el) => (combinedRef.current.sftp_username = el)} error={formDataError?.sftp_username} />
                <MessageLabel text={"SFTP Storage Password"} className="" />
                <AdminCustomInput type="text" name="sftp_password" value={formData?.sftp_password} onChange={handleInput} placeHolder={"Enter SFTP Storage Password (min 6 characters)"} ref={(el) => (combinedRef.current.sftp_password = el)} error={formDataError?.sftp_password} />
                <MessageLabel text={"SFTP Target Directory"} className="" />
                <AdminCustomInput type="text" name="sftp_target_dir" value={formData?.sftp_target_dir || 'public_html/uploads'} onChange={handleInput} placeHolder={"Enter SFTP Target Directory (default: public_html/uploads)"} ref={(el) => (combinedRef.current.sftp_target_dir = el)} error={formDataError?.sftp_target_dir} />
              </Wrapper>
            </RightWrapper>
          </>
          : ""}


        {formData?.gcs_storage === 1 ?
          <>
            <LeftWrapper>
              <Wrapper>
                <MessageHeading text="Google Cloud Storage Configuration" />
                <MessageLabel text={"Bucket Name"} className="" />
                <AdminCustomInput type="text" name="gcs_bucket" value={formData?.gcs_bucket} onChange={handleInput} placeHolder={"Ex: mannanation-media-prod"} ref={(el) => (combinedRef.current.gcs_bucket = el)} error={formDataError?.gcs_bucket} />
                <MessageLabel text={"Project ID"} className="" />
                <AdminCustomInput type="text" name="gcs_project_id" value={formData?.gcs_project_id} onChange={handleInput} placeHolder={"Ex: manna-nation-storage"} ref={(el) => (combinedRef.current.gcs_project_id = el)} error={formDataError?.gcs_project_id} />
                <MessageLabel text={"Region"} className="" />
                <AdminCustomInput type="text" name="gcs_region" value={formData?.gcs_region} onChange={handleInput} placeHolder={"Ex: us-east1"} ref={(el) => (combinedRef.current.gcs_region = el)} error={formDataError?.gcs_region} />
              </Wrapper>

              <Wrapper>
                <MessageHeading text="Service Account" />
                <MessageBox text={"Paste the full Service Account JSON key (downloaded from Google Cloud → IAM → Service Accounts → Keys). Stored encrypted at rest; leave blank when re-saving to keep the existing key."} />
                <MessageLabel text={"Service Account JSON"} className="" />
                <textarea
                  name="gcs_service_account_json"
                  value={formData?.gcs_service_account_json || ''}
                  onChange={handleInput}
                  placeholder={'{ "type": "service_account", "project_id": "...", "private_key": "...", ... }'}
                  rows={8}
                  ref={(el) => (combinedRef.current.gcs_service_account_json = el)}
                  className={`custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color mb-3 ${formDataError?.gcs_service_account_json ? 'custom-input-error' : ''}`}
                />
              </Wrapper>
            </LeftWrapper>

            <RightWrapper>
              <Wrapper>
                <MessageHeading text="Playback Host" />
                <MessageBox text={"Public base URL fronting the bucket (a CDN / custom domain). Leave blank to serve directly from https://storage.googleapis.com/<bucket>."} />
                <MessageLabel text={"Public Base URL"} className="" />
                <AdminCustomInput type="text" name="gcs_public_base_url" value={formData?.gcs_public_base_url} onChange={handleInput} placeHolder={"Ex: https://cdn.mannanation.com"} ref={(el) => (combinedRef.current.gcs_public_base_url = el)} error={formDataError?.gcs_public_base_url} />
              </Wrapper>

              <Wrapper>
                <MessageHeading text="Storage Directories" />
                <MessageLabel text={"Video Directory"} className="" />
                <AdminCustomInput type="text" name="gcs_video_dir" value={formData?.gcs_video_dir || 'uploads/videos'} onChange={handleInput} placeHolder={"Ex: uploads/videos"} ref={(el) => (combinedRef.current.gcs_video_dir = el)} error={formDataError?.gcs_video_dir} />
                <MessageLabel text={"HLS Directory"} className="" />
                <AdminCustomInput type="text" name="gcs_hls_dir" value={formData?.gcs_hls_dir || 'uploads/hls'} onChange={handleInput} placeHolder={"Ex: uploads/hls"} ref={(el) => (combinedRef.current.gcs_hls_dir = el)} error={formDataError?.gcs_hls_dir} />
                <MessageLabel text={"Audio Directory"} className="" />
                <AdminCustomInput type="text" name="gcs_audio_dir" value={formData?.gcs_audio_dir || 'uploads/audios'} onChange={handleInput} placeHolder={"Ex: uploads/audios"} ref={(el) => (combinedRef.current.gcs_audio_dir = el)} error={formDataError?.gcs_audio_dir} />
                <MessageLabel text={"Image Directory"} className="" />
                <AdminCustomInput type="text" name="gcs_image_dir" value={formData?.gcs_image_dir || 'uploads'} onChange={handleInput} placeHolder={"Ex: uploads"} ref={(el) => (combinedRef.current.gcs_image_dir = el)} error={formDataError?.gcs_image_dir} />
              </Wrapper>

              <Wrapper>
                <div className="d-flex align-items-center justify-content-between">
                  <MessageLabel text={"Use Signed URLs (V4)"} noMargin />
                  <AdminSwitch name={'gcs_signed_urls_enabled'} checked={formData?.gcs_signed_urls_enabled == 1} onChange={handleInput} />
                </div>
                <MessageBox text={"Off = public-read objects (simplest). On = time-limited V4 signed URLs (the signer ships in a later release)."} />
                {formData?.gcs_signed_urls_enabled == 1 ? (
                  <>
                    <MessageLabel text={"Signed URL TTL (seconds)"} className="" />
                    <AdminCustomInput type="number" name="gcs_signed_url_ttl" value={formData?.gcs_signed_url_ttl || 21600} onChange={handleInput} placeHolder={"Ex: 21600"} ref={(el) => (combinedRef.current.gcs_signed_url_ttl = el)} error={formDataError?.gcs_signed_url_ttl} />
                  </>
                ) : null}
              </Wrapper>
            </RightWrapper>
          </>
          : null}

        {formData?.aws_storage === 1 ?
          <>
            <LeftWrapper >
              <Wrapper>
                <MessageHeading text="AWS Configuration" />
                <MessageLabel text={"Access Key"} className="" />
                <AdminCustomInput type="text" name="aws_access_key" value={formData?.aws_access_key} onChange={handleInput} placeHolder={"Ex: AKIAIOSFODNN7EXAMPLE"} ref={(el) => (combinedRef.current.aws_access_key = el)} error={formDataError?.aws_access_key} />
                <MessageLabel text={"Secret key"} className="" />
                <AdminCustomInput type="text" name="aws_secret_key" value={formData?.aws_secret_key} onChange={handleInput} placeHolder={"Ex: wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY"} ref={(el) => (combinedRef.current.aws_secret_key = el)} error={formDataError?.aws_secret_key} />
                <MessageLabel text={"Region"} className="" />
                <AdminCustomInput type="text" name="aws_region" value={formData?.aws_region} onChange={handleInput} placeHolder={"Ex: us-east-1"} ref={(el) => (combinedRef.current.aws_region = el)} error={formDataError?.aws_region} />
              </Wrapper >

              <Wrapper>
                <MessageHeading text="Video Storage" />
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <MessageLabel text={"S3 Bucket"} className="mb-0" noMargin />
                  <button type="button" className="btn btn-link btn-sm text-decoration-none p-0 d-flex align-items-center" onClick={() => fetchS3Buckets("aws_video_bucket")} disabled={fetchingBuckets}>
                    <MdRefresh className={`me-1 ${fetchingBuckets && activeBucketField === "aws_video_bucket" ? "fa-spin" : ""}`} />
                    {fetchingBuckets && activeBucketField === "aws_video_bucket" ? "Fetching..." : "Fetch"}
                  </button>
                </div>
                <AdminCustomInput type="text" name="aws_video_bucket" value={formData?.aws_video_bucket} onChange={handleInput} placeHolder={"Ex: my-app-videos"} ref={(el) => (combinedRef.current.aws_video_bucket = el)} error={formDataError?.aws_video_bucket} />
                <MessageLabel text={"Directory"} className="" />
                <AdminCustomInput type="text" name="aws_inputVideoDir" value={formData?.aws_inputVideoDir || 'uploads/videos'} onChange={handleInput} placeHolder={"Ex: uploads/videos"} ref={(el) => (combinedRef.current.aws_inputVideoDir = el)} error={formDataError?.aws_inputVideoDir} />
                <MessageLabel text={"CloudFront Domain"} className="" />
                <AdminCustomInput type="text" name="aws_video_cloudfront_domain" value={formData?.aws_video_cloudfront_domain} onChange={handleInput} placeHolder={"Ex: d111111abcdef8.cloudfront.net"} ref={(el) => (combinedRef.current.aws_video_cloudfront_domain = el)} error={formDataError?.aws_video_cloudfront_domain} />
              </Wrapper>

              <Wrapper>
                <MessageHeading text="Audio Storage" />
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <MessageLabel text={"S3 Bucket"} className="mb-0" noMargin />
                  <button type="button" className="btn btn-link btn-sm text-decoration-none p-0 d-flex align-items-center" onClick={() => fetchS3Buckets("aws_audio_bucket")} disabled={fetchingBuckets}>
                    <MdRefresh className={`me-1 ${fetchingBuckets && activeBucketField === "aws_audio_bucket" ? "fa-spin" : ""}`} />
                    {fetchingBuckets && activeBucketField === "aws_audio_bucket" ? "Fetching..." : "Fetch"}
                  </button>
                </div>
                <AdminCustomInput type="text" name="aws_audio_bucket" value={formData?.aws_audio_bucket} onChange={handleInput} placeHolder={"Ex: my-app-audios"} ref={(el) => (combinedRef.current.aws_audio_bucket = el)} error={formDataError?.aws_audio_bucket} />
                <MessageLabel text={"Directory"} className="" />
                <AdminCustomInput type="text" name="aws_audio_dir" value={formData?.aws_audio_dir || 'uploads/audios'} onChange={handleInput} placeHolder={"Ex: uploads/audios"} ref={(el) => (combinedRef.current.aws_audio_dir = el)} error={formDataError?.aws_audio_dir} />
                <MessageLabel text={"CloudFront Domain"} className="" />
                <AdminCustomInput type="text" name="aws_audio_cloudfront_domain" value={formData?.aws_audio_cloudfront_domain} onChange={handleInput} placeHolder={"Ex: d222222abcdef8.cloudfront.net"} ref={(el) => (combinedRef.current.aws_audio_cloudfront_domain = el)} error={formDataError?.aws_audio_cloudfront_domain} />
              </Wrapper>

            </LeftWrapper>

            <RightWrapper>

              <Wrapper>
                <MessageHeading text="Main Asset Storage" />
                <MessageBox
                  text={`Storage Path Structure — Images: ${formData?.aws_image_dir || 'uploads'}/images, Assets: ${formData?.aws_image_dir || 'uploads'}/subtitles, ${formData?.aws_image_dir || 'uploads'}/advertisement etc.`}
                  classname="text-muted mb-3 d-block"
                />
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <MessageLabel text={"S3 Bucket"} className="mb-0" noMargin />
                  <button type="button" className="btn btn-link btn-sm text-decoration-none p-0 d-flex align-items-center" onClick={() => fetchS3Buckets("aws_bucket")} disabled={fetchingBuckets}>
                    <MdRefresh className={`me-1 ${fetchingBuckets && activeBucketField === "aws_bucket" ? "fa-spin" : ""}`} />
                    {fetchingBuckets && activeBucketField === "aws_bucket" ? "Fetching..." : "Fetch"}
                  </button>
                </div>
                <AdminCustomInput type="text" name="aws_bucket" value={formData?.aws_bucket} onChange={handleInput} placeHolder={"Ex: my-app-main-assets"} ref={(el) => (combinedRef.current.aws_bucket = el)} error={formDataError?.aws_bucket} />

                <MessageLabel text={"Directory"} className="" />
                <AdminCustomInput type="text" name="aws_image_dir" value={formData?.aws_image_dir || 'uploads'} onChange={handleInput} placeHolder={"Ex: uploads"} ref={(el) => (combinedRef.current.aws_image_dir = el)} error={formDataError?.aws_image_dir} />
                <MessageLabel text={"CloudFront Domain"} className="" />
                <AdminCustomInput type="text" name="aws_cloudfront_domain" value={formData?.aws_cloudfront_domain} onChange={handleInput} placeHolder={"Ex: d333333abcdef8.cloudfront.net"} ref={(el) => (combinedRef.current.aws_cloudfront_domain = el)} error={formDataError?.aws_cloudfront_domain} />
              </Wrapper>

              <Wrapper>
                <MessageHeading text="Stream Storage (Transcoding)" />
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <MessageLabel text={"S3 Bucket"} className="mb-0" noMargin />
                  <button type="button" className="btn btn-link btn-sm text-decoration-none p-0 d-flex align-items-center" onClick={() => fetchS3Buckets("outputS3Bucket")} disabled={fetchingBuckets}>
                    <MdRefresh className={`me-1 ${fetchingBuckets && activeBucketField === "outputS3Bucket" ? "fa-spin" : ""}`} />
                    {fetchingBuckets && activeBucketField === "outputS3Bucket" ? "Fetching..." : "Fetch"}
                  </button>
                </div>
                <AdminCustomInput type="text" name="outputS3Bucket" value={formData?.outputS3Bucket} onChange={handleInput} placeHolder={"Ex: my-app-streams"} ref={(el) => (combinedRef.current.outputS3Bucket = el)} error={formDataError?.outputS3Bucket} />
                <MessageLabel text={"Directory"} className="" />
                <AdminCustomInput type="text" name="aws_ouputVideoDir" value={formData?.aws_ouputVideoDir || 'uploads/streams'} onChange={handleInput} placeHolder={"Ex: uploads/streams"} ref={(el) => (combinedRef.current.aws_ouputVideoDir = el)} error={formDataError?.aws_ouputVideoDir} />
                <MessageLabel text={"CloudFront Domain"} className="" />
                <AdminCustomInput type="text" name="aws_stream_cloudfront_domain" value={formData?.aws_stream_cloudfront_domain} onChange={handleInput} placeHolder={"Ex: d444444abcdef8.cloudfront.net"} ref={(el) => (combinedRef.current.aws_stream_cloudfront_domain = el)} error={formDataError?.aws_stream_cloudfront_domain} />
              </Wrapper>


              <Wrapper>
                <MessageHeading text="MediaConvert Configuration (Transcoding)" />
                <MessageLabel text={"Media Convert Role ARN"} className="" />
                <AdminCustomInput type="text" name="aws_mediaConvertRole" value={formData?.aws_mediaConvertRole} onChange={handleInput} placeHolder={"Ex: arn:aws:iam::123456789012:role/MediaConvertRole"} ref={(el) => (combinedRef.current.aws_mediaConvertRole = el)} error={formDataError?.aws_mediaConvertRole} />
                <MessageLabel text={"Media Convert Endpoint"} className="" />
                <AdminCustomInput type="text" name="aws_mediaConvertEndpoint" value={formData?.aws_mediaConvertEndpoint} onChange={handleInput} placeHolder={"Ex: https://xyz.mediaconvert.us-east-1.amazonaws.com"} ref={(el) => (combinedRef.current.aws_mediaConvertEndpoint = el)} error={formDataError?.aws_mediaConvertEndpoint} />
              </Wrapper>

              <Wrapper>
                <MessageHeading text="CloudFront Signed URLs (Restricted Distribution)" />
                <div className="d-flex align-items-center theme-bg-color justify-content-between py-2 mb-3">
                  <MessageLabel text={"Sign CloudFront URLs"} noMargin />
                  <div className="d-inline-block position-relative tooltip-container">
                    <AdminSwitch name={'aws_cloudfront_signed_urls_enabled'} checked={formData?.aws_cloudfront_signed_urls_enabled == 1} onChange={handleInput} />
                    <AdminTooltip text="Enable when the distribution uses Trusted Signers / Trusted Key Groups. Without this, restricted distributions return 'MissingKey'." className="custom-hover-tooltip" position="absolute" bottom="125%" />
                  </div>
                </div>
                {formData?.aws_cloudfront_signed_urls_enabled == 1 && (
                  <>
                    {/* ── Key Pair ID ───────────────────────────────── */}
                    <MessageLabel text={"Key Pair ID"} className="" />
                    <AdminCustomInput
                      type="text"
                      name="aws_cloudfront_key_pair_id"
                      value={formData?.aws_cloudfront_key_pair_id}
                      onChange={handleInput}
                      placeHolder={"Paste the ID from AWS after uploading the public key"}
                      ref={(el) => (combinedRef.current.aws_cloudfront_key_pair_id = el)}
                      error={formDataError?.aws_cloudfront_key_pair_id}
                    />

                    {/* ── Private Key generation ─────────────────────── */}
                    <div className="d-flex align-items-center justify-content-between mb-2 mt-1">
                      <div className="d-flex align-items-center gap-2">
                        <MessageLabel text={"Private Key (RSA-2048)"} noMargin />
                      </div>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm px-3"
                        onClick={generateCloudfrontKeyPair}
                        disabled={isGeneratingKeyPair}
                      >
                        {isGeneratingKeyPair
                          ? <><i className="fa fa-spinner fa-spin me-1" />Generating…</>
                          : <><i className="fa fa-key me-1" />{cfKeyFileExists ? 'Regenerate Key Pair' : 'Generate Key Pair'}</>
                        }
                      </button>
                    </div>

                    {/* ── After generation: show public key + instructions ── */}
                    {generatedPublicKey ? (
                      <div className="mb-3 border rounded p-3" style={{ background: 'rgba(25,135,84,0.06)', borderColor: '#198754 !important' }}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <small className="text-success fw-semibold">
                            <i className="fa fa-check-circle me-1" />
                            Private key saved to server — copy the public key below
                          </small>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary px-2 py-0"
                            onClick={() => {
                              navigator.clipboard.writeText(generatedPublicKey);
                              toast.success('Public key copied to clipboard!');
                            }}
                          >
                            <i className="fa fa-copy me-1" />Copy
                          </button>
                        </div>
                        <pre
                          className="mb-2 p-2 rounded small"
                          style={{ background: '#f8f9fa', fontSize: '11px', maxHeight: '140px', overflowY: 'auto', wordBreak: 'break-all', whiteSpace: 'pre-wrap' }}
                        >
                          {generatedPublicKey}
                        </pre>
                        <small className="text-muted">
                          <strong>Next steps:</strong> Go to{' '}
                          <strong>AWS Console → CloudFront → Public Keys</strong>, create a new key,
                          paste the public key above, then add it to a <strong>Key Group</strong>.
                          AWS will give you a <strong>Key Pair ID</strong> — paste it in the field above and save.
                        </small>
                      </div>
                    ) : (
                      <div className="mb-3 p-3 rounded border" style={{ borderStyle: 'dashed', fontSize: '13px' }}>
                        {cfKeyFileExists
                          ? <span className="text-muted"><i className="fa fa-lock me-1 text-success" />A private key file is already present on the server. Click <strong>Regenerate</strong> to replace it.</span>
                          : <span className="text-muted"><i className="fa fa-info-circle me-1" />Click <strong>Generate Key Pair</strong> to create an RSA-2048 key pair. The private key stays on the server; you upload the public key to AWS.</span>
                        }
                      </div>
                    )}

                    {/* ── TTL ───────────────────────────────────────── */}
                    <MessageLabel text={"Signed URL TTL (seconds)"} className="" />
                    <AdminCustomInput
                      type="number"
                      name="aws_cloudfront_signed_url_ttl"
                      value={formData?.aws_cloudfront_signed_url_ttl || 21600}
                      onChange={handleInput}
                      placeHolder={"21600  (= 6 hours)"}
                      ref={(el) => (combinedRef.current.aws_cloudfront_signed_url_ttl = el)}
                      error={formDataError?.aws_cloudfront_signed_url_ttl}
                    />
                  </>
                )}
              </Wrapper>
            </RightWrapper>
          </>
          : ""}
        {formData?.brightcove_storage === 1 ?
          <>
            <LeftWrapper >
              <Wrapper>
                <MessageHeading text="Brightcove Configuration" />
                <MessageLabel text={"Account ID"} className="" />
                <AdminCustomInput type="text" name="account_id" value={formData?.account_id} onChange={handleInput} placeHolder={"Enter Brightcove Account ID"} ref={(el) => (combinedRef.current.account_id = el)} error={formDataError?.account_id} />
                <MessageLabel text={"Policy Key"} className="" />
                <AdminCustomInput type="text" name="policy_key" value={formData?.policy_key} onChange={handleInput} placeHolder={"Enter Brightcove Policy Key"} ref={(el) => (combinedRef.current.policy_key = el)} error={formDataError?.policy_key} />
                <MessageLabel text={"API Base URL"} className="" />
                <AdminCustomInput type="text" name="api_base_url" value={formData?.api_base_url || 'https://edge.api.brightcove.com/playback/v1'} onChange={handleInput} placeHolder={"Enter API Base URL"} ref={(el) => (combinedRef.current.api_base_url = el)} error={formDataError?.api_base_url} />
                <MessageLabel text={"Cache Duration (seconds)"} className="" />
                <AdminCustomInput type="number" name="cache_duration" value={formData?.cache_duration} onChange={handleInput} placeHolder={"Enter Cache Duration"} ref={(el) => (combinedRef.current.cache_duration = el)} error={formDataError?.cache_duration} />
              </Wrapper >
            </LeftWrapper >
            <RightWrapper>
              <Wrapper>
                <MessageHeading text="OAuth Credentials" />
                <MessageLabel text={"Client ID"} className="" />
                <AdminCustomInput type="text" name="client_id" value={formData?.client_id} onChange={handleInput} placeHolder={"Enter OAuth Client ID"} ref={(el) => (combinedRef.current.client_id = el)} error={formDataError?.client_id} />
                <MessageLabel text={"Client Secret"} className="" />
                <AdminCustomInput type="text" name="client_secret" value={formData?.client_secret} onChange={handleInput} placeHolder={"Enter OAuth Client Secret"} ref={(el) => (combinedRef.current.client_secret = el)} error={formDataError?.client_secret} />
              </Wrapper>
            </RightWrapper>
          </>
          : ""}

      </FormContainer>
      <AdminCustomButton saveMethod={handleAction} saveText="Update Settings" className="ms-auto d-flex justify-content-end" />

      {showBucketModal && (
        <AdminAwsBucketSelectModal
          modelClose={showBucketModal}
          closeModal={() => setShowBucketModal(false)}
          action={(selectedBucket) => handleBucketSelect(selectedBucket)}
          modalHead="Available S3 Buckets"
          option={s3Buckets.map(b => ({ id: b.name, title: b.name }))}
        />
      )}

      <AdminBunnyCdnSyncModal
        open={showBunnySyncModal}
        onClose={() => setShowBunnySyncModal(false)}
      />
    </>
  );
}
export default StorageSettings;
